import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MobileSideNavService {
  constructor() {}
  isOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);
  viewId: BehaviorSubject<number | string> = new BehaviorSubject(0);
  isAccountSetupOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);

  isDiscoveryScaffoldingOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);

  addVaultSidenavToggleSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  locationTemplateSidenavToggleSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  
  list: BehaviorSubject<object> = new BehaviorSubject({
    name: 'Family',
    path_id: 1,
    user_discovery_path_id: 1,
    details: Array(2),
    percent_complete: 15,
  });

  isCollectionOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);
  collectionList: BehaviorSubject<object> = new BehaviorSubject({
    name: 'Personal Documents',
    path_id: 3,
    user_discovery_path_id: 3,
    details: Array(2),
    collection_status: 'complete',
  });
  isFinancialAccountSetupOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);

  handleNav(val: boolean) {
    this.isOpened.next(val);
  }

  handleViewId(val: number | string) {
    this.viewId.next(val);
  }

  handleCollection(val: boolean) {
    this.isCollectionOpened.next(val);
  }

  handleCollectionList(val: object) {
    this.collectionList.next(val);
  }

  handleAccountSetupSidenav(val: boolean) {
    this.isAccountSetupOpened.next(val);
  }

  // handleAccountSetupType(val: string) {
  //   this.accountSetupType.next(val);
  // }

  handleDiscovery(val: boolean) {
    this.isDiscoveryScaffoldingOpened.next(val);
  }

  handleList(val: object) {
    this.list.next(val);
  }

  handleAddVaultSidenav(payload) {
    this.addVaultSidenavToggleSubject.next(payload);
  }

  handleLocationTemplateSidenav(payload) {
    this.locationTemplateSidenavToggleSubject.next(payload);
  }

  handleFinancialAccountSetupSidenav(val: boolean) {
    this.isFinancialAccountSetupOpened.next(val);
  }
}
